<template>
    <snippet-card :modelValue="props.modelValue">
        <template v-slot:actions>
            <div v-if="!FEATURES.contact_groups || !belongsToCorporate" class="flex flex-row gap-2 w-full sm:w-auto">
                <vx-dropdown placement="right">
                    <vx-button data-test="rule-dropdown"
                        type="button"
                        color="muted"
                        outline
                        class="w-[45px]">
                        <font-awesome-icon widthAuto :icon="faEllipsis" />
                    </vx-button>

                    <template v-slot:items>
                        <vx-dropdown-item data-test="delete"
                            @click="deleteSnippet()">
                            Delete
                            <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
                        </vx-dropdown-item>
                    </template>
                </vx-dropdown>

                <vx-button v-if="props.templateView"
                    data-test="edit-button"
                    :href="`/messaging/snippets/templates/${props.modelValue.id}`"
                    color="muted"
                    class="w-full sm:w-auto"
                    outline>
                    Edit <font-awesome-icon widthAuto :icon="faFilePen" />
                </vx-button>
                <vx-button v-else
                    @click.prevent="emit('edit', props.modelValue)"
                    :data-test="`edit-btn-${props.modelValue.id}`"
                    color="muted"
                    class="w-full sm:w-auto"
                    outline>
                    Edit <font-awesome-icon widthAuto :icon="faFilePen" />
                </vx-button>
            </div>
            <div v-else-if="props.groupId && props.modelValue.is_locked" class="w-full sm:w-auto">
                <vx-button
                    :href="`/messaging/quick-blast?snippet_id=${props.modelValue.id}`"
                    :data-test="`send-${props.modelValue.id}`"
                    color="muted"
                    class="w-full"
                    outline>
                    Send <font-awesome-icon widthAuto :icon="faRocket" />
                </vx-button>
            </div>
        </template>
    </snippet-card>
</template>

<script setup>
import { faEllipsis, faFilePen, faRocket, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { VxButton, VxDropdown, VxDropdownItem, VxSwal } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed, inject } from 'vue';
import { snippetsClient } from '~/services';
import { throwSwalRequestError } from '~/utils/request';
import SnippetCard from '~/components/snippets/components/SnippetCard.vue';

const FEATURES = inject('FEATURES');

const props = defineProps({
    orgUnitId: Number,
    groupId: String,
    modelValue: {
        type: Object,
        required: true,
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
    templateView: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['deleted', 'edit']);

const belongsToCorporate = computed(() => props.modelValue.is_template && (props.groupId || props.orgUnitId));

const deleteSnippet = () => {
    VxSwal.confirmation(
        'Delete Snippet',
        'Are you sure? There is no undo.',
        'danger',
        () => snippetsClient.deleteSnippet({
            teamId: props.modelValue.team_id,
            groupId: props.modelValue.group_id,
            orgUnitId: props.modelValue.org_unit_id,
        }, props.modelValue.id)
            .then(() => emit('deleted', props.modelValue.id))
            .catch(throwSwalRequestError),
    );
};
</script>
